import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 pad40 centered"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600 centered" }, [
  /*#__PURE__*/_createTextVNode(" こちらの予定は既に調整した日程を過ぎたため、再調整/キャンセルできません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("お相手の方にチャットを利用しお伝えください。 ")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "w100 pad40 centered"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600 centered" }, [
  /*#__PURE__*/_createTextVNode(" こちらの予定は投票形式で確定したため、オーナー以外再調整/キャンセルできません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("オーナーにお伝えください。 ")
], -1)
const _hoisted_11 = {
  key: 2,
  class: "w100 pad40"
}
const _hoisted_12 = {
  key: 0,
  class: "title mc"
}
const _hoisted_13 = {
  key: 0,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_14 = {
  key: 1,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_15 = {
  key: 2,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_16 = {
  key: 3,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "fw400 fs13"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "w100 llgreyBg pad15 rad10"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "mb15"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = {
  key: 4,
  class: "mt20"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "強制的に変更する日程を選択します。", -1)
const _hoisted_27 = { class: "ml15" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { key: 5 }
const _hoisted_31 = {
  key: 0,
  class: "fw600 fs12"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "同時に確定したすべての調整ページで実行します。", -1)
const _hoisted_33 = {
  key: 1,
  class: "fw600 fs12"
}
const _hoisted_34 = {
  key: 2,
  class: "fw600 fs12"
}
const _hoisted_35 = {
  key: 3,
  class: "fw600 fs12"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_40 = { class: "fs14 fw400" }
const _hoisted_41 = {
  key: 2,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_42 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_43 = { class: "fs14 fw400" }
const _hoisted_44 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "別日程でカスタム確定", -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "参加者に通知", -1)
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_RoomLightOverViewContent = _resolveComponent("RoomLightOverViewContent")!
  const _component_RadioButtonTag = _resolveComponent("RadioButtonTag")!
  const _component_ChangeableDateTimeContent = _resolveComponent("ChangeableDateTimeContent")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CancelAppointmentModal",
    "content-class": "modalContent shadowContent rad10 modalStandard",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        style: _normalizeStyle({
                height: _ctx.action == `force_fix` && _ctx.changeableEv ? `520px` : _ctx.from == `rooms` ? `520px` : `380px`,
            })
      }, [
        (_ctx.alreadyFinished())
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                width: "40",
                height: "40",
                class: "centered",
                style: {"margin-top":"40px"}
              }, null, 8, _hoisted_2),
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]))
          : (_ctx.isVotedNotOwnerUg())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                  width: "40",
                  height: "40",
                  class: "centered",
                  style: {"margin-top":"40px"}
                }, null, 8, _hoisted_7),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.appo && _ctx.selectedMessageRoom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_ctx.selectedMessageRoom.is_voted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, " 確定した日程を一斉に再調整/キャンセル "))
                        : (_ctx.appoStatus == _ctx.Appointment.typeReschedule)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t(`schedule.reschedule_scheduled_event`)), 1))
                          : (_ctx.appoStatus == _ctx.Appointment.typeCancel)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(`schedule.cancel_scheduled_event`)), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t(`schedule.cancel_or_reschedule_scheduled_event`)), 1))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_17,
                (_ctx.from == `rooms` && _ctx.selectedMessageRoom && !_ctx.selectedMessageRoom.is_voted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_RoomLightOverViewContent, {
                        room: _ctx.selectedMessageRoom,
                        appo: _ctx.appo
                      }, null, 8, ["room", "appo"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.appoStatus == _ctx.Appointment.typeReschedule)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_ctx.Util.isPresent(_ctx.pdm.currentPds))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdm.currentPds, (pd, pdindex) => {
                              return (_openBlock(), _createElementBlock("p", {
                                class: "fl mr10 fs14 warningText arial",
                                key: pdindex
                              }, _toDisplayString(pd.jp_format) + "  ", 1))
                            }), 128)),
                            _hoisted_21
                          ]))
                        : (_ctx.Util.isPresent(_ctx.pdm.currentPd))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("p", {
                                class: _normalizeClass(`${_ctx.isSP ? `fs16` : `fs24`} warningText  arial centered fw600`),
                                style: {
                                marginTop: `23px`,
                            }
                              }, _toDisplayString(_ctx.pdm.currentPd.jp_format), 3)
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_RadioButtonTag, {
                        options: _ctx.cancelOptions(),
                        optionName: `company_type`,
                        defaultOption: _ctx.action,
                        type: `horizon`,
                        onSelect: _ctx.selectAction,
                        style: {"margin-top":"23px"}
                      }, null, 8, ["options", "defaultOption", "onSelect"])
                    ])),
                _hoisted_24,
                (_ctx.action == `force_fix` && _ctx.changeableEv)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ChangeableDateTimeContent, {
                          changeableEv: _ctx.changeableEv,
                          onUpdateAppoTime: _ctx.updateAppoTime
                        }, null, 8, ["changeableEv", "onUpdateAppoTime"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_28,
                _hoisted_29,
                (_ctx.appo && _ctx.selectedMessageRoom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (_ctx.selectedMessageRoom.is_voted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                            _hoisted_32,
                            _createTextVNode(_toDisplayString(_ctx.$t(`message.send_with_message`)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.$t(`message.send_with_message`)), 1)),
                      (!_ctx.showRescheduleButton())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.$t(`message.open_period_has_passed`)), 1))
                        : (_ctx.selectedMessageRoom.is_voted && _ctx.action != `force_fix`)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.$t(`message.canceled_dates_cannot_be_restored`)), 1))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_TextareaTag, {
                  placeholder: "急用で参加できなくなりました。申し訳ありませんが、別日程で何卒よろしくお願いいたします。",
                  style: {"height":"100px"},
                  class: "fs14 roundForm mw100",
                  value: _ctx.typedMessage,
                  onInputValue: _ctx.inputMessage
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_36,
                _hoisted_37,
                _hoisted_38
              ]))
      ], 4),
      (_ctx.alreadyFinished() || _ctx.isVotedNotOwnerUg())
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("section", {
              class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
            }, [
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t(`title.close`)), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("section", {
                class: "with_white_bg dgrey fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
              }, [
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t(`title.close`)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              (_ctx.appoStatus == _ctx.Appointment.typeReschedule)
                ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
                    (_ctx.pdm.currentPd)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "w100 skyblueBg fs16 pointer centered fw600",
                          style: {"line-height":"50px","height":"50px"},
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                        }, _toDisplayString(_ctx.$t(`schedule.update_event`)), 1))
                      : (_ctx.pdm.currentPds)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "w100 skyblueBg fs16 pointer centered fw600",
                            style: {"line-height":"50px","height":"50px"},
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                          }, " この日程を再提案 "))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "w100 alertRedBg fs16 pointer centered fw600",
                            style: {"line-height":"50px","height":"50px"},
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                          }, _toDisplayString(_ctx.$t(`schedule.notify_attendees`)), 1))
                  ]))
                : (_ctx.action == `force_fix`)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                      _createElementVNode("div", {
                        class: "w100 alertRedBg fs16 pointer centered",
                        style: {"line-height":"50px","height":"50px"},
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                      }, _hoisted_48)
                    ]))
                  : (_openBlock(), _createElementBlock("section", {
                      key: 2,
                      class: "w100 alertRedBg fs16 pointer centered",
                      style: {"line-height":"50px","height":"50px"},
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                    }, _hoisted_50))
            ])
          ]))
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}